import { render, staticRenderFns } from "./ThanksWire.vue?vue&type=template&id=1ffadcf7&scoped=true&"
import script from "./ThanksWire.vue?vue&type=script&lang=js&"
export * from "./ThanksWire.vue?vue&type=script&lang=js&"
import style0 from "./ThanksWire.vue?vue&type=style&index=0&id=1ffadcf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffadcf7",
  null
  
)

export default component.exports